import type React from "react";
import documentStyles from "~/components/Document/documentStyles.module.scss";
import styles from "./styles.module.scss";

interface RenderedPreviewProps {
  showRenderedPreview: boolean;
  previewVersion: "before" | "after";
  setPreviewVersion: (version: "before" | "after") => void;
  isEditing: boolean;
  previewHasContent: boolean;
  renderedPreviewHtml: string | null;
  previewPaneStyle: React.CSSProperties;
  previewBodyRef: React.RefObject<HTMLDivElement>;
  handlePreviewResizeMouseDown: (event: React.MouseEvent<HTMLDivElement>) => void;
}

export const RenderedPreview: React.FC<RenderedPreviewProps> = ({
  showRenderedPreview,
  previewVersion,
  setPreviewVersion,
  isEditing,
  previewHasContent,
  renderedPreviewHtml,
  previewPaneStyle,
  previewBodyRef,
  handlePreviewResizeMouseDown,
}) => {
  if (!showRenderedPreview) return null;

  return (
    <>
      <div
        className={styles["resizeHandle"]}
        onMouseDown={handlePreviewResizeMouseDown}
        role="presentation"
      />
      <div className={styles["renderedPreview"]} style={previewPaneStyle}>
        <div className={styles["renderedPreviewHeader"]}>
          <h4>全文プレビュー</h4>
          <div
            className={styles["previewVersionToggle"]}
            role="group"
            aria-label="プレビューバージョン切り替え"
          >
            <button
              type="button"
              className={`${styles["segment"]} ${previewVersion === "before" ? styles["segmentActive"] : ""}`}
              onClick={() => setPreviewVersion("before")}
              aria-pressed={previewVersion === "before"}
            >
              変更前
            </button>
            <button
              type="button"
              className={`${styles["segment"]} ${previewVersion === "after" ? styles["segmentActive"] : ""}`}
              onClick={() => setPreviewVersion("after")}
              aria-pressed={previewVersion === "after"}
            >
              変更後
            </button>
          </div>
        </div>
        <div className={styles["renderedPreviewBody"]} ref={previewBodyRef}>
          {isEditing && (
            <div className={styles["renderedPreviewHint"]}>
              編集中の内容がプレビューに反映されています。
            </div>
          )}
          <div
            className={`${documentStyles["document-content"]} ${styles["renderedPreviewContainer"]}`}
          >
            <div className={documentStyles["innerDiv"]}>
              <div className={documentStyles["markdown-mode-content"]}>
                {!previewHasContent || !renderedPreviewHtml ? (
                  <div className={styles["renderedPreviewEmpty"]}>
                    プレビューできる内容がありません。
                  </div>
                ) : (
                  <div
                    className={`${documentStyles["markdown-content"]} ${styles["renderedPreviewContent"]}`}
                    dangerouslySetInnerHTML={{ __html: renderedPreviewHtml }}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
